angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/components/messages/messages.html',
    '<div class="project-messages-number">{{messages.length}}</div>\n' +
    '<h3 class="mb30">Messages</h3>\n' +
    '<div ng-show="user.IsClient && messages.length==0" class="alert alert-messages alert-info" role="alert">\n' +
    '	<a class="close alt" data-dismiss="alert" aria-label="Close"></a>\n' +
    '		You don\'t have any messages at the moment. We will notify you immediately upon message received.\n' +
    '</div>\n' +
    '<!-- 1st -->\n' +
    '<div ng-repeat="message in messages">\n' +
    '    <ul class="list-inline user-messages">\n' +
    '        <li class="user-profile-photo">\n' +
    '            <div class="user-photo" style="background-image:url({{message.pictureUrl}}),url(assets/img/avatar.png);"></div>\n' +
    '        </li>\n' +
    '        <li>\n' +
    '            <h5>{{message.name}}</h5>\n' +
    '        </li>\n' +
    '        <li class="date-stamp">\n' +
    '            <small>{{message.CreatedDate|calendarMethod}}</small>\n' +
    '        </li>\n' +
    '    </ul>\n' +
    '    <div class="message-text" style="word-wrap: break-word; white-space: pre-wrap;">{{message.Message}}\n' +
    '        <div ng-if="message.Attachment != null" style=" white-space: normal;">\n' +
    '            <small><a ng-href="{{message.Attachment.Url}}" target="_blank" download>{{message.Attachment.Name}}</a></small>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<!-- Reply -->\n' +
    '<div class="message-box">\n' +
    '    <form id="messageForm" name="messageForm" ng-submit="sendMessage()">\n' +
    '        <h5>Message</h5>\n' +
    '        <textarea required="true" ng-maxlength="2000" class="form-control" ng-model="message" rows="5" placeholder="REPLY" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'REPLY\'" id="message" name="message"></textarea>\n' +
    '        <div class="help-block" ng-class="{ \'errors\': messageForm.message.$touched && messageForm.message.$invalid }" ng-messages="messageForm.message.$error" ng-if="messageForm.message.$touched">\n' +
    '            <p ng-message="required">This field is required</p>\n' +
    '            <p ng-message="minlength">This field is too short.</p>\n' +
    '            <p ng-message="maxlength">This field is too long.</p>\n' +
    '        </div>\n' +
    '        <!-- Attachment -->\n' +
    '        <div class="row mt10">\n' +
    '            <div class="col-sm-4 col-md-3 mt5">\n' +
    '                <span ng-show="!file" class="btn-file alt">Attach file<input type="file" ngf-select ng-model="file" ngf-max-size="20MB" ngf-validate="{size: {max: \'20MB\'}}"></span>\n' +
    '            </div>\n' +
    '            <div class="col-sm-8 col-mb-7">\n' +
    '                <!-- Hide on opening -->\n' +
    '                <div id="file-attached" class="">\n' +
    '                    <small>{{file.name}}</small>\n' +
    '                    <a ng-show="file" href="javascript:;" class="trash" ng-click="removeFile()"></a>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="text-right mt5">\n' +
    '            <button type="submit" class="btn btn-primary" ng-disabled="messageForm.$invalid" data-toggle="modal" data-target="#modal-sent">Send</button>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</div>\n' +
    '<script type="text/ng-template" id="modal-sent.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Message Sent</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Your message sent successfully.\n' +
    '            <br>\n' +
    '            {{name}}\n' +
    '            will receive this notification immediately.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" class="btn btn-primary" ng-click="$close();">OK</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '');
}]);
